import { CreationToolProps, CreationToolWrapperProps } from "@kaltura/mediaspace-shared-search-and-select";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { CustomComponent } from "@kaltura/mediaspace-shared-ui";
import { Button, Typography } from "@kaltura/ds-react-components";
import { ArrowLeft24Icon } from "@kaltura/ds-react-icons";
import { SearchAndSelectEntry } from "@kaltura/mediaspace-shared-types";

interface AddQuizCreationToolWrapperProps extends CreationToolWrapperProps {
    onSubmit: (entry: SearchAndSelectEntry) => void;
}

/**
 * Creation tool (upload, recorder, etc.) wrapper for the quiz creation page.
 */
export const CreationToolWrapper = (props: AddQuizCreationToolWrapperProps) => {
    const { creationTool, onBack, onSubmit } = props;

    return (
        <div>
            <Button variant={"borderless"} color={"secondary"} startIcon={<ArrowLeft24Icon />} onClick={onBack}>
                {translate("Back")}
            </Button>

            <Typography component={"h1"} variant="h2">
                {(creationTool.props as CreationToolProps).title}
            </Typography>
            <CustomComponent component={creationTool} onSubmit={onSubmit} onBack={onBack} />
        </div>
    );
};
